import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getUserData } from '../lib/client';

const LandingPage = () => {
  const navigate = useNavigate();
  const user = getUserData()

  useEffect(() => {
    if (user) {
      if (user.primary_group_id) {
        // primary group이 있으면 해당 그룹 페이지로 이동
        navigate(`/groups/${user.primary_group_id}`, { replace: true });
      } else {
        // primary group이 없으면 그룹 목록 페이지로 이동
        navigate('/groups', { replace: true });
      }
    } else {
      navigate('/auth', { replace: true });
    }
  }, [user, navigate]);

  return null
};

export default LandingPage;
